import React from "react";
import { Form } from "react-bootstrap";

const PROVIDER_LABELS = {
  google: "Google Gemini",
  anthropic: "Anthropic Claude",
  openai: "OpenAI GPT",
};

export const LLMModelSelector = ({
  provider,
  onProviderChange,
  modelName,
  onModelChange,
  modelOptions,
  modelsLoading,
  temperature,
  onTemperatureChange,
  showTemperature = true,
  temperatureGuidance,
}) => {
  const getDefaultGuidance = () => {
    if (!modelName) return "0 = Focused, 1 = Creative";
    if (modelName.includes("gemini")) return "Recommended: 0.9-1.0 (Google)";
    if (modelName.includes("claude")) return "Recommended: 0.7-1.0 (Anthropic)";
    if (modelName.includes("gpt") || modelName.includes("o1") || modelName.includes("o3") || modelName.includes("o4")) return "Recommended: 0.7-1.0 (OpenAI)";
    return "0 = Focused, 1 = Creative";
  };

  return (
    <div style={{ display: "flex", gap: "32px" }}>
      <Form.Group style={{ width: "100%" }}>
        <Form.Label style={{ fontWeight: "bold" }}>AI Provider</Form.Label>
        <Form.Select
          value={provider}
          onChange={(e) => onProviderChange(e.target.value)}
        >
          {Object.entries(PROVIDER_LABELS).map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </Form.Select>
      </Form.Group>

      <Form.Group style={{ width: "100%" }}>
        <Form.Label style={{ fontWeight: "bold" }}>AI Model</Form.Label>
        {modelsLoading ? (
          <Form.Control type="text" value="Loading models..." disabled />
        ) : modelOptions && modelOptions[provider] ? (
          <Form.Select
            value={modelName}
            onChange={(e) => onModelChange(e.target.value)}
          >
            {modelOptions[provider].map((model) => (
              <option key={model.value} value={model.value}>
                {model.label}
              </option>
            ))}
          </Form.Select>
        ) : (
          <Form.Control type="text" value="No models available" disabled />
        )}
      </Form.Group>

      {showTemperature && (
        <Form.Group style={{ width: "100%" }}>
          <Form.Label style={{ fontWeight: "bold" }}>
            LLM Warmth{" "}
            <span style={{ fontWeight: "normal", fontSize: "0.85em", color: "#6c757d" }}>
              ({temperatureGuidance || getDefaultGuidance()})
            </span>
          </Form.Label>
          <Form.Control
            required
            type="number"
            min="0"
            max="1.5"
            step="0.01"
            placeholder="Enter LLM warmth value between 0 and 1.5"
            value={temperature}
            name="temperature"
            onChange={(e) => onTemperatureChange(e.target.value)}
          />
        </Form.Group>
      )}
    </div>
  );
};
